import clsx from 'clsx';
import { HubertCard } from 'components/HubertUI/HubertCard';
import type { ComponentProps } from 'react';

interface Props extends ComponentProps<'div'> {
  className?: string;
}

const PaginatedTableFilterCard = ({ className = '', children }: Props) => {
  return (
    <div className={clsx('w-full', 'pt-6', 'flex items-center justify-center')}>
      <HubertCard className={clsx('md:w-1/2', 'flex flex-col', 'p-6', className)}>{children}</HubertCard>
    </div>
  );
};

export default PaginatedTableFilterCard;
